import styled from 'styled-components';
import Colors from '../../../helpers/Colors'
export const TextStyle = styled.p`
    color: ${Colors.neutral};
    font-size: 1em;
    font-family: Tittilium Web
`;

export default TextStyle;